import Grid from '@mui/material/Grid';
import { errorMessage } from 'constants/CommonConstants';
import { formRequiredRules } from 'helper';
import React, { useImperativeHandle } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { InputRadio } from 'sharedComponents/inputGroup/InputRadio';
import { BUDGET_OPTION } from '../LeadGenConstant';
import { Lead } from '../LeadGenInterface';
import { AnyAction, ThunkDispatch } from '@reduxjs/toolkit';
import { RootState } from 'store/store';
import { useDispatch, useSelector } from 'react-redux';
import { postLeadCreation } from 'store/LeadCreationState';
import { StepperFromProps } from 'sharedComponents/dynamicStepperForm/dynamicStepperFormInterface';

const BudgetSelection: React.ForwardRefRenderFunction<unknown, StepperFromProps> = (
  { onNext, onBack, isSubmit, mappedData },
  ref
) => {
  // Hooks
  const { t } = useTranslation();

  const hasCalledNextStep = React.useRef(false);

  // Redux
  const dispatch: ThunkDispatch<RootState, AnyAction, AnyAction> = useDispatch();

  const { authenticateClientData } = useSelector((state: RootState) => state.auth) || {};
  const widgetData = authenticateClientData?.data?.widgetData || {};

  // React Hook Form
  const { control, trigger, getValues } = useFormContext();

  // React Hook Form Trigger
  const nextStep = async () => {
    if (hasCalledNextStep.current) return;
    hasCalledNextStep.current = true;

    const { budget } = getValues();

    const budgetData: Lead = {
      leadSourceId: widgetData?.leadSourceId,
      isSubmit,
      leadDetails: {
        Budget: budget,
        ...mappedData,
      },
    };

    dispatch(postLeadCreation({ data: budgetData, leadTypeID: widgetData?.leadTypeId })).then((res) => {
      if (
        res?.payload?.success &&
        (res?.payload?.data?.draftLeadId || res?.payload?.data?._id || res?.payload?.data?.Lead?.leadId)
      ) {
        onNext?.();
      }
    });
  };

  const backStep = () => {
    onBack?.();
  };

  useImperativeHandle(ref, () => ({
    nextStep,
    backStep,
  }));

  return (
    <>
      <h3 className='dy-stepper-form__body__title text-center'>{t('leadGen.whatyourBudget')}</h3>
      <InputRadio
        rules={formRequiredRules(errorMessage(t).radioError)}
        name={'budget'}
        control={control}
        options={BUDGET_OPTION(t)}
        directionRow={false}
        triggerValidationForField={(name: string) => {
          trigger(name);
          onNext?.();
        }}
        radioVariant='outline'
        itemPerRow={{
          xs: 12,
          md: 6,
        }}
      />
    </>
  );
};

const BudgetSelectionStep = React.forwardRef(BudgetSelection);

export default BudgetSelectionStep;
